import { BarceloComponent } from "components-utils";

const AllStructure = {
  bwdArticleHeader: BarceloComponent({
    selector: ".bwd-article-header, .bwd-article-header-dl-id",
    path: "bwd/structure/bwd-article-header/js/bwd-article-header",
  }),

  bwdHeader: BarceloComponent({
    selector: ".bwd-header, .bwd-header-dl-id",
    path: "bwd/structure/bwd-header/js/bwd-header",
  }),

  bwdNavigationMenu: BarceloComponent({
    selector: ".bwd-navigation-menu, .bwd-navigation-menu-dl-id",
    path: "bwd/structure/bwd-navigation-menu/js/bwd-navigation-menu",
  }),

  bwdPackageDetail: BarceloComponent({
    selector: ".bwd-package-detail, .bwd-package-detail-dl-id",
    path: "bwd/structure/bwd-package-detail/js/bwd-package-detail",
  }),
};

export default AllStructure;
